import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { boat_details } from './boats.schema';

export const tasks = sqliteTable('tasks', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),
  user_id: integer('user_id'),
  name: text('name'),
  scope: text('scope'),
  type: text('type'),
  notes: text('notes'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
  boat_detail_uuid: text('boat_detail_uuid').references(() => boat_details.id),
  status: text('status'),
  priority: integer('priority'),
  completed_at: text('completed_at'),
  due_date: text('due_date'),
  is_recurring: integer('is_recurring'),
  frequency: text('frequency'),
  assignee_ids: text('assignee_ids'),
  invite_ids: text('invite_ids'),
  has_notification: integer('has_notification'),
  time_unit: integer('time_unit'),
  time_unit_type: text('time_unit_type'),
  parent_id: integer('parent_id'),
  marked_as_maintenance: integer('marked_as_maintenance'),
  has_usage_reminder: integer('has_usage_reminder'),
  usage_time_unit: integer('usage_time_unit'),
  usage_time_unit_type: text('usage_time_unit_type'),
  usage_recurrence_time_unit: integer('usage_recurrence_time_unit'),
  usage_recurrence_time_unit_type: text('usage_recurrence_time_unit_type'),
  usage_is_custom: integer('usage_is_custom'),
  category_id: integer('category_id'),
  category_uuid: text('category_uuid'),
  is_enabled: integer('is_enabled'),
  organization_id: text('organization_id'),
  /** With both a date and a usage rule: `or` is due on whichever comes first, `and` once both are. */
  recurrence_type: text('recurrence_type'),
  /** Every N units of the maintained item's usage log (engine hours, litres, cycles). */
  usage_interval: real('usage_interval'),
  /** The item's reading when the task was last done — the usage counter's zero. */
  usage_baseline: real('usage_baseline'),
  /** `[{"inventory_uuid": "...", "quantity": 1}]` — taken out of stock when the task is marked done. */
  planned_parts: text('planned_parts'),
  /**
   * When a recurring task was last done. It stays open after a completion; `completed_at` is what
   * closes a task, and every task bucket reads it that way.
   */
  last_completed_at: text('last_completed_at'),
});
